<template>
  <div class="GeneralCourse">
    <div class="ContainerBtnRegister">
      <button
        class="ItemSumRegisters"
        @click="getStudentStatus('aprovado')"
        name="aprovado"
        style="border: 3px ridge #48b865"
      >
        <span class="titleCountRegisters">
          Aprovados ( {{ this.counter.aprovado }} )
        </span>
      </button>
      <button
        class="ItemSumRegisters"
        @click="getStudentStatus('pendente')"
        name="pendente"
        style="border: 3px ridge #777777"
      >
        <span class="titleCountRegisters">
          Pendentes ( {{ this.counter.pendente }} )
        </span>
      </button>
      <button
        class="ItemSumRegisters"
        @click="getStudentStatus('reprovado')"
        name="reprovado"
        style="border: 3px ridge #cf4848"
      >
        <span class="titleCountRegisters">
          Reprovados ( {{ this.counter.reprovado }} )
        </span>
      </button>
      <button
        class="ItemSumRegisters"
        @click="readRegistration"
        name="customer"
        style="border: 3px ridge #0188c8"
      >
        <span class="titleCountRegisters">
          Total (
          {{
            this.counter.aprovado +
            this.counter.reprovado +
            this.counter.pendente
          }}
          )
        </span>
      </button>
    </div>
    <div class="SearchCourse">
      <div class="searchInput">
        <b-form-select
          class="searchFilter"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="type"
          :options="filterCombobox"
        ></b-form-select>
        <b-input
          size="sm"
          placeholder="Pesquisar"
          v-model="search"
          class="inputSearch"
          @keyup.enter="getStudentStatus()"
        ></b-input>
        <b-button size="sm" @click="getStudentStatus()" class="searchBtn">
          <b-icon-search></b-icon-search>
        </b-button>
        <div class="searchInputAll" style="justify-content: flex-end">
          <button class="searchAll" @click="readRegistration()">
            ver tudo
          </button>
        </div>
      </div>
    </div>
    <div>
      <div class="ContainerSearchInput">
        <div class="textRegister">
          <span>Matrículas Registradas</span>
        </div>
      </div>
      <div class="ContentTable" style="color: #3a4750; width: 100%">
        <div
          v-for="registration in Registration"
          :key="registration.id"
          @click.stop="findById(registration)"
          class="rowCLient"
        >
          <span
            class="notResult"
            :style="`width: 50px; height: 50px; background-image: url(${notImg}); background-repeat: no-repeat; background-size: contain; background-position: center center`"
          />
          <div class="celTable" style="width: 30%; min-width: 30%">
            <span class="textEllipsis">
              <strong>Aluno: </strong>
              <strong
                style="
                  color: #403b74;
                  font-weight: bold;
                  text-transform: uppercase;
                  padding-left: 3px;
                "
                >{{ registration.student.name }}</strong
              >
            </span>
            <span class="textEllipsis">
              <strong>CPF: </strong>
              {{ registration.student.cpf || "000.000.000-00" }}</span
            >
          </div>
          <div class="celTable" style="width: 20%">
            <span class="textEllipsis"
              ><strong>Contato: </strong>{{ registration.student.phone }}</span
            >
            <span
              class="textEllipsis"
              v-if="registration.student.isResideForaVicosa === 0"
              ><strong>Reside em Viçosa? </strong>Sim</span
            >
            <span v-else class="textEllipsis"
              ><strong>Reside em Viçosa? </strong>Não</span
            >
          </div>
          <div class="celTable" style="width: 25%; min-width: 25%">
            <span class="textEllipsis"
              ><strong style="padding-right: 5px">Curso: </strong
              >{{ registration.course.name }}</span
            >
          </div>
          <div class="celTable" style="width: 15%">
            <span class="textEllipsis"
              ><strong>Status: </strong>{{ registration.status }}</span
            >
          </div>
          <div class="celTableActions">
            <div class="btnActions">
              <b-dropdown
                id="dropdown-1"
                class="btnActions1"
                variant="none"
                size="sm"
              >
                <template #button-content>
                  <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                </template>
                <b-dropdown-item @click.stop="findById(registration)">
                  Detalhes
                </b-dropdown-item>
                <b-dropdown-item
                  @click.stop="openFinanceiroBoleto(registration.studentCourseId)"
                >
                  Financeiro
                </b-dropdown-item>
                <b-dropdown-item
                  v-b-modal.modal-excluir
                  @click.stop="stockTheId(registration.id)"
                >
                  Excluir
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="spinGeneral" class="loadingLazy">
      <div class="loader"></div>
    </div>

    <div :class="sizeModalRegister">
      <div :class="modalContainer" v-if="colapseRegister">
        <b-button class="closeModalRegister" @click="modalHeight"> X </b-button>
        <Registration class="cardContentModal" />
      </div>
    </div>
    <b-modal id="modal-boleto" hide-footer hide-header centered>
      <div>
        <div class="contentTitle">
          <h6 class="titleModalReversalOrDelete">Anexar Boleto</h6>
        </div>

        <section
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 20px;
            margin-top: 20px;
            margin-bottom: 15px;
            padding: 0 10px;
          "
        >
          <div style="width: 100%">
            <label for="file-upload" class="file-label"
              >Escolha o boleto para anexar:</label
            >
            <b-form-file
              id="file-upload"
              v-model="uploadedFile"
              placeholder="Nenhum arquivo selecionado"
              drop-placeholder="Solte o arquivo aqui..."
              accept=".pdf, .jpg, .jpeg, .png"
              browse-text="Anexar"
            ></b-form-file>
          </div>
          <div style="width: 100%">
            <b-form-checkbox
              class="footerTitle"
              size="sm"
              id="checkbox-1"
              v-model="confirmDelete"
              name="checkbox-1"
            >
              Estou ciente e desejo realizar o envio do boleto.
            </b-form-checkbox>
          </div>
        </section>

        <div class="btnsModalActions">
          <button class="btnCancel" @click="$bvModal.hide('modal-boleto')">
            Não
          </button>
          <button
            class="btnConfirm"
            style="position: relative"
            @click="submitFile"
          >
            Enviar boleto
            <span
              v-if="spinLoadingActionsButton"
              style="position: absolute; right: 5px"
              ><b-spinner small
            /></span>
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-excluir" hide-footer hide-header centered>
      <div>
        <div class="contentTitle">
          <h6 class="titleModalReversalOrDelete">Excluir</h6>
        </div>

        <section
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 20px;
            margin-top: 20px;
            margin-bottom: 15px;
            padding: 0 10px;
          "
        >
          <div style="width: 100%">
            <p class="subTitle" style="margin: 0">
              O item selecionado esta prestes a ser excluido!
            </p>
          </div>

          <div style="width: 100%">
            <b-form-checkbox
              class="footerTitle"
              size="sm"
              id="checkbox-1"
              v-model="confirmDelete"
              name="checkbox-1"
            >
              Estou ciente e desejo excluir.
            </b-form-checkbox>
          </div>
        </section>

        <div class="btnsModalActions">
          <button class="btnCancel" @click="$bvModal.hide('modal-excluir')">
            Não
          </button>
          <button
            @click.stop="deleteRegistration(stockId)"
            class="btnConfirm"
            style="position: relative"
          >
            Sim, excluir
            <span
              v-if="spinLoadingActionsButton"
              style="position: absolute; right: 5px"
              ><b-spinner small
            /></span>
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Registration from "./Registration.vue";
import { mapMutations, mapState } from "vuex";
import CourseService from "../../services/course";
import notImg from "../../assets/notImg.png";

export default {
  components: {
    Registration,
  },
  data() {
    return {
      counter: {},
      tableActive: {
        course: true,
      },
      notImg: notImg,
      supplierLenght: 0,
      alterCourse: null,
      studentName: "",
      search: "",
      courseName: "",
      type: "",
      startDate: "",
      endDate: "",
      Registration: [],
      filterCombobox: [
        { value: "studentName", text: "Nome" },
        { value: "courseName", text: "Curso" },
        { value: "", text: "Todos" },
      ],
      confirmDelete: false,
      spinLoadingActionsButton: false,
      spinGeneral: false,
      uploadedFile: null,
      selectedStudent: "",
      idRegister: "",
      stockId: "",
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_REGISTRATION",
    ]),

    openModalToReceive(Registration) {
      this.SET_DATA_SEARCH_FROM_REGISTRATION(Registration);

      const name = "registration";
      this.ALTER_TYPE_REGISTER(name);
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    async stockTheId(id) {
      this.stockId = id;
    },
    async findById(registration) {
      try {
        this.openModalToReceive(registration);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      }
    },

    async readRegistration() {
      try {
        this.spinGeneral = true;
        const { data } = await CourseService.allStudentCourse();

        this.Registration = data;
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    async deleteRegistration(id) {
      try {
        this.spinGeneral = true;
        await CourseService.deleteRegistration(id);
        this.$toast.open({
          message: "Deletado com sucesso",
          type: "info",
        });

        this.$bvModal.hide("modal-excluir");
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível deletar!",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
        window.location.reload();
      }
    },

    async activeTable(event) {
      const button = event.currentTarget;
      const name = button.name;
      this.tableActive = {
        course: false,
        [name]: true,
      };
    },

    modalHeight() {
      this.SET_COLAPSE_REGISTER(!this.colapseRegister);
      this.colapseRegister
        ? this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral")
        : this.ALTER_SIZE_MODAL_REGISTER("disable");
      this.modalContainer
        ? this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer")
        : this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");

      if (!this.colapseRegister && this.sizeModalRegister === "disable") {
        this.SET_DATA_SEARCH_FROM_REGISTRATION({});
      }
    },

    async handleModals(name) {
      this.ALTER_TYPE_REGISTER(name);

      this.modalHeight();
    },

    async countRegisters() {
      const data = await CourseService.getCountCourse();
      this.counter = data.data;
    },

    async getStudentStatus(status) {
      const { data } = await CourseService.getStudentStatus(
        status || "Aprovado",
        this.type,
        this.search
      );
      this.Registration = data;
      this.type = "";
      this.search = "";
    },

    async submitFile() {
      if (!this.confirmDelete) {
        alert("Você precisa confirmar antes de enviar.");
        return;
      }
      if (!this.uploadedFile) {
        alert("Por favor, anexe um arquivo.");
        return;
      }
      if (!this.selectedStudent) {
        alert("Por favor, selecione um estudante.");
        return;
      }

      this.spinLoadingActionsButton = true;

      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(this.uploadedFile);
      });

      const body = {
        id: this.selectedStudent,
        documents: [
          {
            base64,
            key: "boleto",
          },
        ],
        typeRef: "student-course",
      };

      try {
        await CourseService.uploadFiles(body);
        this.$bvModal.hide("modal-boleto");

        return this.$toast.open({
          message: "Boleto enviado com Sucesso",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            "Erro ao enviar boleto. Verifique o arquivo e tente novamente!",
          type: "info",
        });
      } finally {
        this.spinLoadingActionsButton = false;
      }
    },

    openFinanceiroBoleto(id) {
      this.selectedStudent = id;
      this.$bvModal.show("modal-boleto");
    },

    getIdRegister(idRegister) {
      this.idRegister = idRegister;
    },
  },
  computed: {
    ...mapState({
      sizeModalRegister: (state) => state.sizeModalRegister,
      typeRegister: (state) => state.typeRegister,
      colapseRegister: (state) => state.colapseRegister,
      modalContainer: (state) => state.modalContainer,
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
  },
  mounted() {
    this.readRegistration();
  },
  created() {
    this.countRegisters();
    this.SET_COLAPSE_REGISTER(false);
    this.SET_DATA_SEARCH_FROM_REGISTRATION({});
    this.ALTER_SIZE_MODAL_REGISTER("disable");
    this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_REGISTRATION({});
  },
  watch: {
    async getAllCourse() {
      await this.readRegistration();
    },
    isSearchRegisters() {
      this.readRegistration();
    },
  },
};
</script>
<style scoped>
.GeneralCourse {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: auto;
  font-size: 13px;
}

.ContainerBtnRegister {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 50px;
  width: 100%;
  gap: 30px;
  padding: 20px 0;
  border-bottom: 1px solid rgb(227, 227, 227);
}

.BtnRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.SearchCourse {
  display: flex;
  width: 100%;
  height: 55px;
  border: 1px solid rgb(227, 227, 227);
  box-shadow: 0px 10px 4px -10px rgba(142, 142, 142, 0.78);
  justify-content: center;
  align-items: center;
}

.ItemSumRegisters {
  width: 25%;
  height: 40px;
  border-radius: 5px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.ItemSumRegisters:hover {
  background: rgba(245, 245, 245, 0.546);
}
.ItemSumRegisters:focus {
  background: rgba(245, 245, 245, 0.764);
}

.verified {
  display: flex;
  width: 100%;
  height: 70px;
}

.searchInput {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(https://cdn-icons-png.flaticon.com/512/271/271210.png)
    right 0.75rem center / 8px 10px no-repeat !important;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.searchInputAll {
  width: 30%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 48px;
  left: 61px;
  height: calc(100% - 45px);
  max-height: calc(100% - 45px);
  overflow: auto;
  width: calc(100% - 55px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.cardContentModal {
  width: 85vw;
  margin-top: 20px;
  margin-left: 5vw;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 4px;
  width: 100%;
  min-height: 40vh;
  max-width: 100%;
}

.rowCLient {
  display: flex;
  align-items: center;
  background: rgba(245, 245, 245, 0.608);
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  height: 65px;
  gap: 20px;
  padding: 2px 10px;
  cursor: context-menu;
  font-size: 12px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.131);
}

.rowCLient:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.celTableInfos {
  display: flex;
  gap: 20px;
  width: 20%;
  height: 50px;
  text-align: center;
  justify-content: flex-end;
  align-items: flex-end;
}

.countItem {
  width: 20px;
  border-radius: 5px;
  background-color: rgb(0, 81, 169);
  color: white;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgb(31, 30, 30);
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
  border-radius: 5px;
  height: 20px;
  background: rgb(238, 238, 238);
  font-size: 10px !important;
  font-weight: normal !important;
  padding: 10px;
  color: #001c29;
  margin: 0;
  height: 25px;
}

.celTableActions {
  display: flex;
  gap: 10px;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.notResult {
  max-height: 50px;
  border-radius: 50%;
  max-width: 50px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 29px;
}

.trTable {
  text-align: center;
  height: 29px;
  cursor: context-menu;
  font-size: 12px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

tbody tr:hover {
  background: rgb(194, 193, 193);
  cursor: pointer;
}

th {
  font-weight: 500;
  font-size: 12px;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.wtsTd {
  display: flex;
  gap: 2px;
  padding-top: 5px;
  cursor: pointer;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.ContainerSearchInput {
  display: flex;
  align-items: center;
  height: 37px;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchInput {
  width: 50%;
  display: flex;
}

.searchInputAll {
  width: 50%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 40vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: fixed;
}

.contentTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 10px;
  background-color: #0188c8;
  border-radius: 5px;
  color: white;
  margin: 0;
}

.subTitle {
  color: #767676;
  font-size: 14px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  margin: 0;
}

.titleModalReversalOrDelete {
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
  text-align: center;
}

.footerTitle {
  color: #0188c8;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
}

.btnsModalActions {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnConfirm {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnCancel {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #0188c8;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ContainerSearchInput {
    padding: 3px;
  }
  .textRegister {
    font-size: 12px;
  }
  .searchInput {
    width: 60%;
  }
  .searchFilter {
    height: 25px;
    font-size: 11px;
  }
  .form-control-sm {
    padding: 0.25rem 1.2rem;
    height: 25px;
    font-size: 12px;
  }
  .searchBtn {
    right: 10px;
    height: 25px;
    display: flex;
    align-items: center;
  }
  .searchAll {
    font-size: 11px;
    padding: 2px 10px;
  }
  .ContentTable {
    height: 50vh;
    max-height: 50vh;
    padding: 5px;
  }
  .headTable {
    height: 25px;
  }
  .trTable {
    height: 25px;
    font-size: 11px;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 700px) {
  .ContainerSearchInput {
    display: flex;
    align-items: center;
    height: 70px;
    gap: 5px;
    width: 100%;
    justify-content: center;
    padding: 0;
    flex-direction: column;
  }

  .searchInput {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 3px 0 0;
  }

  .searchInputAll {
    width: 150px !important;
  }

  .rowCLient {
    gap: 5px;
    padding: 2px 5px;
    font-size: 10px;
    border-left: 5px solid rgb(64, 59, 116) !important;
  }

  .celTableInfos {
    display: none;
  }

  .celTable {
    width: 33% !important;
  }

  .ContentTable {
    padding: 5px;
    overflow: auto;
    gap: 2px;
  }

  .notResult {
    display: none;
  }

  .trTable {
    font-size: 9px;
  }

  .whatsapp {
    display: none;
  }

  .searchAll {
    font-size: 10px;
    padding: 5px 10px;
  }

  .form-control-sm {
    padding: 0.25rem 0.5rem !important;
    font-size: 10px;
  }

  .searchFilter {
    width: 100px;
    font-size: 10px;
  }
}

.closeModalRegister:hover {
  background: whitesmoke;
  color: red;
}

.closeModalRegister:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.titleCountRegisters {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .titleCountRegisters {
    font-size: 10px;
  }
  .ItemSumRegisters {
    gap: 0px;
    width: 45%;
    height: 45px;
    justify-content: space-between;
  }
  .GeneralCourse {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
  .BtnRegister {
    width: 45%;
    font-size: 10px;
    height: 25px;
  }
  .ContainerBtnRegister {
    margin-top: 0px;
    padding-bottom: 20px;
  }
  .SearchCourse {
    height: 74px;
    margin-top: 50px;
  }
}

@media screen and (max-width: 700px) {
  .cardContentModal {
    width: 100vw;
    margin-top: 30px;
    margin-left: 0vw;
  }

  .GeneralCourse {
    margin-left: 0px;
    width: 100%;
    height: 100vh;
    font-size: 11px;
  }

  .SearchCourse {
    margin: 55px 0 10px 0;
    gap: 20px;
    padding: 0 0 10px 0;
    justify-content: center;
    align-items: center;
  }

  .ItemSumRegisters {
    width: 45%;
    height: 50px;
    gap: 0px;
    font-size: 10px;
    justify-content: center;
  }

  .ContainerBtnRegister {
    margin-top: 0px;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .BtnRegister {
    width: 45%;
    height: 40px;
    font-size: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .ModalGeneral {
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }
}
</style>